import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import NavBar from '../NavBar';
import LanguageSelector from '../../LanguageSelector';

const HeaderMenu = ({
  isHomePage,
  handleChangeLanguage,
  logo,
  isHeaderSticky,
  routeTree,
  activeItem,
  setActiveItem,
  handleNavigation,
  selectedItem,
  mobileLogo,
  styles,
}) => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div
      id="header"
      className={cn(styles.headerMenu, {
        [styles.simpleHeaderMenuContainer]: !isHomePage,
        [styles.homePageHeaderMenuContainer]: isHomePage,
      })}
    >
      <div className={styles.left}>
        <Link to="/">
          <img
            src={logo}
            className={cn(styles.logo, {
              [styles.textLogo]: !isHomePage,
            })}
            alt="logo"
          />
        </Link>
        <Link to="/">
          <img
            src={mobileLogo}
            className={cn(styles.mobileLogo, {
              [styles.mobileLogoHomePage]: isHomePage && !isHeaderSticky,
              [styles.mobileHomePageStickyLogo]: isHomePage && isHeaderSticky,
            })}
            alt="logo"
          />
        </Link>
      </div>
      <div className={styles.center}>
        <div
          className={cn({
            [styles.navbarInHomePage]: isHomePage,
          })}
        >
          <NavBar
            routeTree={routeTree}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            onSubClickHandler={handleNavigation}
            currentPath={pathname}
            selectedItem={selectedItem}
          />
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.languageSelector}>
          <LanguageSelector
            onLanguageChange={(language) => handleChangeLanguage(language)}
            selectedLanguage={i18n.language}
          />
        </div>
        {/* Uncomment in the future, when authentication is ready */}
        {/* <UserAuthButtons /> */}
      </div>
    </div>
  );
};

HeaderMenu.propTypes = {
  isHomePage: PropTypes.bool.isRequired,
  handleChangeLanguage: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  mobileLogo: PropTypes.string.isRequired,
  isHeaderSticky: PropTypes.bool.isRequired,
  routeTree: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      icon: PropTypes.element,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          path: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  activeItem: PropTypes.shape({
    header: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        path: PropTypes.string,
      }),
    ),
  }),
  setActiveItem: PropTypes.func.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    header: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        path: PropTypes.string,
      }),
    ),
  }),
  styles: PropTypes.shape({
    languageSelector: PropTypes.string,
    right: PropTypes.string,
    navbarInHomePage: PropTypes.string,
    center: PropTypes.string,
    mobileLogo: PropTypes.string,
    mobileLogoHomePage: PropTypes.string,
    mobileHomePageStickyLogo: PropTypes.string,
    logo: PropTypes.string,
    left: PropTypes.string,
    headerMenu: PropTypes.string,
    simpleHeaderMenuContainer: PropTypes.string,
    homePageHeaderMenuContainer: PropTypes.string,
    textLogo: PropTypes.string,
  }).isRequired,
};

HeaderMenu.defaultProps = {
  selectedItem: null,
  activeItem: null,
};

export default HeaderMenu;
